<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style src="@/assets/css/base.css"></style>
<style>
html, body {
  height: 100%;
  width: 100%;
  overflow: hidden;
  touch-action: manipulation;
}
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  color: #2c3e50;
  font-size: 16px;
  width: 100%;
  height: 100%;
  font-family: AIFont;
}
@font-face {
  font-family: AIFont;
  src: url(./assets/font/NotoSansJP-VariableFont_wght.ttf);
  /* src:url('rajdhani-bold.ttf'),url('rajdhani-bold.eot'); */
}
/* Medium */
@font-face {
  font-family: MediumFont;
  src: url(./assets/font/static/NotoSansJP-Medium.ttf);
}
/* Regular */
@font-face {
  font-family: RegularFont;
  src: url(./assets/font/static/NotoSansJP-Regular.ttf);
}
/* Thin */
@font-face {
  font-family: ThinFont;
  src: url(./assets/font/static/NotoSansJP-Thin.ttf);
}
/* SemiBold */
@font-face {
  font-family: SemiBoldFont;
  src: url(./assets/font/static/NotoSansJP-SemiBold.ttf);
}
/* Bold */
@font-face {
  font-family: BoldFont;
  src: url(./assets/font/static/NotoSansJP-Bold.ttf);
}
@media screen and (min-width: 1439px) {
  #app {
    padding-top: 36px; /* no*/
    height: calc(100% - 36px); /* no*/
    /* background: linear-gradient(
      180deg,
      #a0e1ff 0%,
      rgba(184, 243, 255, 0) 100%
    ); */
    background: url("./assets/img/bg_app.png") repeat-x top center;
    background-size: 100% 100%;
  }
  ::-webkit-scrollbar {
    width: 6px; /* no*/
    border-radius: 4px; /* no*/
  }

  /*为滚动条轨道添加样式*/
  ::-webkit-scrollbar-track {
    background: rgb(241, 248, 255, 0);
    border-radius: 4px; /* no*/
  }
  /*为滚动条滑块添加样式*/
  ::-webkit-scrollbar-thumb {
    background: rgb(0, 0, 0, 0.2);
    /* background: rgba(235, 245, 255, 0.96); */
    border-radius: 4px; /* no*/
  }
  /*为活动的滚动条控件添加样式*/
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(0, 0, 0, 0.2);
    border-radius: 4px; /* no*/
  }
}
input[type="search"] {
  -webkit-appearance: none;
}
[type="search"]::-webkit-search-decoration {
  display: none;
}
input::-webkit-search-cancel-button {
  display: none;
}
html,body,.mainPage,.mainBox,.aiCenter,.modelPage,.myCenterMain{
overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue